<template>
<div>
  <bs-card class="card-info text-center">
    <div class="p-2">
      <h4>{{ r.customer.name }}</h4>
      <div class="d-flex align-items-center justify-content-center" v-for="contact in r.contacts" :key="'contact' + contact.id">
        <avatar :user="contact" />
        <strong class="ml-2">{{ contact.name }}</strong>
        <small v-if="contact.phone1" class="ml-2">(<a :href="'tel:' + contact.phone1">{{ contact.phone1 }}</a>)</small>
        <small v-if="contact.primary" class="ml-2">({{ $t('labels.primary') }})</small>
      </div>
      <hr>
      <ul class="list-group list-group-flush">
        <li v-if="r.property" class="list-group-item d-flex justify-content-between align-items-center px-3">
          <small class="text-uppercase">{{ $tc('labels.property', 1) }}:</small>
          <span>{{ r.property.label }}</span>
        </li>
        <li v-if="r.multi_day" class="list-group-item d-flex justify-content-between align-items-center px-3">
          <small class="text-uppercase">{{ $t('labels.booking') }}:</small>
          <span>
              <span>{{ r.due_at | luxon:format('MMM d') }}</span>
              <span> - </span>
              <span>{{ r.end_at | luxon:format('MMM d') }}</span>
          </span>
        </li>
        <li v-else class="list-group-item d-flex justify-content-between align-items-center px-3">
          <small class="text-uppercase">{{ $t('labels.time') }}:</small>
          <span>{{ r.due_at | luxon:format('h:mma') }}</span>
        </li>
      </ul>
      <div class="alert alert-info my-2" v-if="r.description">
        {{ r.description }}
      </div>
      <ul class="list-group list-group-flush text-left">
        <li class="list-group-item" v-for="task in r.tasks" :key="'t' + task.id">
          <input class="form-check-input" type="checkbox" :value="task.pivot_id" :id="'t' + task.id" @change="toggleTask($event, task)" :checked="task.complete">
          <label class="form-check-label" :for="'t' + task.id">
            <span>{{ task.label }}</span><br>
            <small>{{ task.description }}</small>
          </label>
        </li>
      </ul>
      <div class="d-flex pt-3 px-2 flex-wrap">
        <div class="position-relative mr-1 mb-1" v-for="file in r.files" :key="'img' + file.id">
          <button @click="destroy(r.id, file.id)" class="btn btn-action position-absolute" style="top: 0; right: 0">
            <fa-icon :icon="['fas', 'times']" />
          </button>
          <img :src="file.thumbnail" class="img-thumbnail" />
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <div class="card-footer">
        <bs-button class="btn-secondary" @click="update(r)">
          <fa-icon :icon="['fal', 'clipboard']" class="mr-2" />
          <span>{{ $t('labels.photos_notes') }}</span>
        </bs-button>
      </div>
    </template>
  </bs-card>
  <bs-modal :name="'create-' + $options.name" :label="$t('labels.action_task', { action: $t('labels.edit') })">
    <bs-form :submit="$t('labels.submit')" @submit="submitQty">
      <template v-slot:default="slotProps">
        <tuxedo-input :type="'number'" :name="'quantity'" :label="$t('labels.quantity')" v-model="resource.quantity" :help="$t('tips.quantity')" :error="slotProps.error"></tuxedo-input>
      </template>
    </bs-form>
  </bs-modal>
  <bs-modal :name="'schedule-notes-' + r.id" :label="$t('labels.action_resource', { action: $t('labels.create'), resource: $t('labels.note') })">
    <bs-form :submit="$t('labels.submit')" @submit="submit">
      <template v-slot:default="slotProps">
        <multi-image-upload :label="$t('labels.add_photo')" v-model="resource.images" :error="slotProps.error" />
        <text-field :name="'notes'" :label="$t('labels.notes')" v-model="resource.notes" :error="slotProps.error"></text-field>
      </template>
    </bs-form>
  </bs-modal>
  <bs-modal :name="'destroy-image-' + r.id" :label="$t('labels.action_resource', { action: $t('labels.destroy'), resource: $t('labels.image') })">
    <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
      {{ $t('messages.delete', { resource: 'Image' }) }}
    </bs-form>
  </bs-modal>
</div>
</template>

<script>
export default {
  name: 'BookingCard',
  props: ['r', 'collection'],
  data () {
    return {
      hideLabel: Object.prototype.hasOwnProperty.call(this.$attrs, 'hideLabel'),
      activeId: null,
      resource: {
        id: null,
        complete: null,
        quantity: 0,
        images: {},
        notes: ''
      }
    }
  },
  methods: {
    toggleTask (e, task) {
      this.resource.id = e.target.value
      this.resource.complete = e.target.checked
      this.resource.quantity = 0
      if (task.consumable && e.target.checked) {
        this.$modal.show('create-' + this.$options.name)
      } else {
        this.$store.dispatch('update', {
          path: 'my-schedule-today',
          collection: this.collection,
          resource: this.resource
        })
      }
    },
    update (o) {
      this.resource = JSON.parse(JSON.stringify(o))
      this.$modal.show('schedule-notes-' + o.id)
    },
    submitQty () {
      this.$store.dispatch(this.resource.id ? 'update' : 'store', {
        path: 'my-schedule-today',
        collection: this.collection,
        resource: this.resource
      }).then(() => {
        this.$modal.hide('create-' + this.$options.name)
      })
    },
    submit () {
      this.$store.commit('submitting', true)
      this.$store.dispatch('chunk', {
        url: '/api/schedule/' + this.resource.id,
        resource: this.resource,
        icon: ['fal', 'calendar-alt'],
        message: this.$t('messages.uploading_image'),
        callback: (res) => {
          this.$store.commit('processResponse', { collection: this.collection, data: res.data })
        }
      }).then(() => {
        this.$modal.hide('schedule-notes-' + this.resource.id)
      })
    },
    destroy (o, a) {
      this.resource.id = o
      this.activeId = a
      this.$modal.show('destroy-image-' + this.resource.id)
    },
    destruction () {
      this.$store.dispatch('destroy', {
        path: 'schedule',
        id: this.resource.id,
        tag: 'asset',
        tag_id: this.activeId,
        collection: this.collection
      }).then(() => {
        this.$modal.hide('destroy-image-' + this.resource.id)
      })
    }
  }
}
</script>
